import { render } from "./CategoryList.vue?vue&type=template&id=91cde61e"
import script from "./CategoryList.vue?vue&type=script&lang=js"
export * from "./CategoryList.vue?vue&type=script&lang=js"

import "./CategoryList.vue?vue&type=style&index=0&id=91cde61e&lang=scss"

import exportComponent from "/Users/pinkpanther/Desktop/Front End/Vue/直播班/nature-gift/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__